import { render } from "./eventComponent.vue?vue&type=template&id=e94f6dbe"
import script from "./eventComponent.vue?vue&type=script&lang=js"
export * from "./eventComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__